import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import fuzzysort from 'fuzzysort';
import { ComboboxOption, Highlight } from '@zillow/constellation';

/**
 * Highlights the label based on fuzzysort's result. The default option of using a regex isn't flexible enough
 * to cover all use cases
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.search
 * @returns {import('@zillow/constellation').ComboboxOption}
 */
export default function HighlightedComboboxOption({ label, search, ...rest }) {
  const preparedLabel = useMemo(() => fuzzysort.prepare(label), [label]);
  const labelNode = fuzzysort.highlight(fuzzysort.single(search, preparedLabel), (match, index) => (
    <Highlight key={index}>{match}</Highlight>
  ));
  return <ComboboxOption label={labelNode ?? label} {...rest} />;
}

HighlightedComboboxOption.propTypes = {
  label: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
};
